<script setup lang="ts">
/**
 * UI-kit component
 * Category: Other
 * Name: ListDropdown
 */

defineOptions({
  name: 'ListDropdown',
})
</script>

<template>
  <div class="ui-list-dropdown">
    <slot />
  </div>
</template>

<style lang="scss" scoped src="../styles/_list-dropdown.scss" />
